"use client";

import { useWidgetResizing } from "@repo/design-system/hooks/use-widget-resizing";
import { cn } from "@repo/design-system/utils/cn";
import Head from "next/head";
import type { CSSProperties, Ref } from "react";
import { useEffect } from "react";
import { Joblist } from "~/components/job-board/joblist-eon";

export function JobListWidgetEon({
  className,
  themeStyle,
}: {
  className?: string;
  /** Scoped CSS variables for subclients without global theme entries */
  themeStyle?: CSSProperties;
}) {
  const { heightRef, announceHeight } = useWidgetResizing("fswidget_joblist");

  // Announce height of the widget to the parent, when the results change
  useEffect(() => {
    announceHeight();
  }, [announceHeight]);

  return (
    <>
      <Head>
        <title>4S Job List Widget</title>
      </Head>

      <style>{`
        .joblist-widget-container {
          container-type: inline-size;
          width: 100%;
          min-height: 80px;
        }

        @container (max-width: 400px) {
          .joblist-widget-content {
            padding: 0.5rem;
          }
        }

        @container (min-width: 401px) and (max-width: 768px) {
          .joblist-widget-content {
            padding: 1rem;
          }
        }

        @container (min-width: 769px) {
          .joblist-widget-content {
            padding: 1.5rem;
          }
        }
      `}</style>

      <div
        className="joblist-widget-container"
        ref={heightRef as Ref<HTMLDivElement>}
        style={themeStyle}
      >
        <div className={cn("joblist-widget-content", className)}>
          <Joblist hideWatchColumn />
        </div>
      </div>
    </>
  );
}
